//@flow
import SessionStore from './sessionStoreClass';

export default new SessionStore();
